export default "__VITE_ASSET__Bng$cWMk__"